import { formatTime } from 'utils/formatDateTime';
import type { OrderStatus } from 'utils/transportOrder';

type EtaAppearance = { color: string; iconName: string };

const STATUS_ETA_APPEARANCE: Record<OrderStatus, EtaAppearance> = {
    ON_TIME: { color: 'label-info', iconName: 'icon-time' },
    DELIVERED: { color: 'label-success', iconName: 'icon-ok-sign' },
    DELAYED: { color: 'label-warning', iconName: 'icon-time' },
    STOPPED: { color: 'label-danger', iconName: 'icon-exclamation-sign' },
};

const UNKNOWN_APPEARANCE: EtaAppearance = { color: 'label-default', iconName: 'icon-time' };

export type OrderEtaLabelProps = {
    status: OrderStatus | undefined;
    etaAt: string | undefined;
};

const OrderEtaLabel = ({ status, etaAt }: OrderEtaLabelProps) => {
    const { color, iconName } = status === undefined ? UNKNOWN_APPEARANCE : STATUS_ETA_APPEARANCE[status];

    return (
        <span className={`label ${color} label-filled label-condensed white-space-nowrap`}>
            <span className={`uikit-icon ${iconName}`} aria-hidden='true' />
            <span>{etaAt === undefined ? 'No ETA' : formatTime(etaAt)}</span>
        </span>
    );
};

export default OrderEtaLabel;
